import { useFormikContext } from 'formik';
import type { FormikValues } from 'formik';

import type { IWizardData } from './types';

const useWizardData = (): IWizardData => {
  const { values, isValid, errors } = useFormikContext<FormikValues>();

  return { values, isValid, errors };
};

export default useWizardData;
